export default {
  apiHost: '/api',
};
